import { render } from "./table.html?vue&type=template&id=f46e811a&external"
import script from "./table.js?vue&type=script&lang=js&external"
export * from "./table.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__